import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['requestForDocument', 'checkVacancy', 'feeConfirmation', 'checkMoveinConditions', 'tourOfFacility']

  connect () {
    if (this.hasRequestForDocumentTarget) {
      this.changeCheckboxRequired()
    }
  }

  changeCheckboxRequired () {
    if (this.isAtLeastOneChecked()) {
      this.requestForDocumentTarget.required = false
      this.checkVacancyTarget.required = false
      this.feeConfirmationTarget.required = false
      this.checkMoveinConditionsTarget.required = false
      this.tourOfFacilityTarget.required = false
    } else {
      this.requestForDocumentTarget.required = true
      this.checkVacancyTarget.required = true
      this.feeConfirmationTarget.required = true
      this.checkMoveinConditionsTarget.required = true
      this.tourOfFacilityTarget.required = true
    }
  }

  isAtLeastOneChecked () {
    return (
      this.requestForDocumentTarget.checked ||
      this.checkVacancyTarget.checked ||
      this.feeConfirmationTarget.checked ||
      this.checkMoveinConditionsTarget.checked ||
      this.tourOfFacilityTarget.checked
    )
  }
}
